/*
 * View for the survey tab on the Topic page
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicSurvey/template/topicSurveyTemplate.html",
], function (Marionette, TopicSurveyTemplate) {
  var TopicSurveyView = {};

  TopicSurveyView.topicSurveyLayout = Marionette.Layout.extend({
    template: TopicSurveyTemplate,
    regions: {
      surveyChart: "#surveyChart",
    },
  });
  return TopicSurveyView;
});
